import { MappableModel } from './mappable-model'

export class Survey extends MappableModel {
  public id: number
  public name: string
  public code: string
  public survey_url: string

  private _site_url: string
  private _persoan_url: string

  public get site_url(): string {
    if (!this._site_url) {
      const splitUrl: string[] = (this.survey_url || '').split('/survey/show/')
      this._site_url = splitUrl[0]
    }
    return this._site_url
  }

  public get persona_url(): string {
    if (!this._persoan_url) {
      this._persoan_url = this.site_url + '/register/who/' + encodeURIComponent(this.code)
    }
    return this._persoan_url
  }
}
